import React from 'react';

export const PricingSummary = ({ pricing }) => {
  if (pricing.days <= 0) return null;

  return (
    <div
      data-testid="pricing-summary"
      className="bg-[#050814] border border-[#B8860B]/30 p-4 rounded-lg space-y-2"
    >
      <div className="flex justify-between text-[#F4F1EA]/80">
        <span>Rental ({pricing.days} days)</span>
        <span className="font-semibold text-[#F4F1EA]">${pricing.rental_amount.toFixed(2)}</span>
      </div>
      {pricing.deposit > 0 && (
        <div className="flex justify-between text-[#F4F1EA]/80">
          <span>Deposit</span>
          <span className="font-semibold text-[#F4F1EA]">${pricing.deposit.toFixed(2)}</span>
        </div>
      )}
      {pricing.add_ons_amount > 0 && (
        <div className="flex justify-between text-[#B8860B]">
          <span>Add-ons</span>
          <span className="font-semibold">${pricing.add_ons_amount.toFixed(2)}</span>
        </div>
      )}
      <div className="border-t border-[#B8860B]/20 pt-2 flex justify-between text-lg font-bold text-[#B8860B]">
        <span>Total</span>
        <span>${pricing.total.toFixed(2)}</span>
      </div>
      {pricing.deposit > 0 && (
        <p className="text-xs text-[#F4F1EA]/60 mt-2">*Deposit refunded upon equipment return</p>
      )}
    </div>
  );
};
